import { createInstance } from '@/helpers/api/base'
import { Area } from '@/types/area'
import { useAppQuery } from '@/helpers/api/query'

const AREAS_KEY = 'AREAS'

export const useGetAreas = () =>
    useAppQuery<Area[]>({
        queryKey: [AREAS_KEY],
        queryFn: () =>
            createInstance({
                url: '/hubs/areas',
                method: 'GET',
            }),
        staleTime: Infinity,
    })
